// Mock data para testing del dashboard
export const mockDashboardData = {
  graficasFavoritas: [
    {
      _id: "64f1a2b3c4d5e6f7a8b9c0d1",
      nombre: "Consumo Eléctrico Principal",
      tipo: { _id: "tipo1", nombre: "Línea" },
      tipografica: { _id: "tipog1", nombre: "Consumo" },
      proyecto: {
        _id: "proj1",
        nombre: "Edificio Central",
        empresa: {
          _id: "empresa1",
          nombre: "Empresa Principal"
        }
      },
      sensores: [
        {
          _id: "sensor1",
          nombre: "Sensor KW Principal",
          alias: "KW_MAIN",
          unidades: "kW",
          tipo: { _id: "tipo_sensor1", nombre: "Kilowatt" },
          empresa: "empresa1",
          data: [
            { value: 45.2, date: "2024-01-15T10:00:00Z" },
            { value: 47.8, date: "2024-01-15T11:00:00Z" },
            { value: 43.1, date: "2024-01-15T12:00:00Z" },
            { value: 49.5, date: "2024-01-15T13:00:00Z" },
            { value: 51.2, date: "2024-01-15T14:00:00Z" },
            { value: 48.9, date: "2024-01-15T15:00:00Z" },
            { value: 46.7, date: "2024-01-15T16:00:00Z" },
            { value: 44.3, date: "2024-01-15T17:00:00Z" },
            { value: 42.8, date: "2024-01-15T18:00:00Z" },
            { value: 41.5, date: "2024-01-15T19:00:00Z" }
          ]
        }
      ],
      createdAt: "2024-01-15T08:30:00Z",
      favorita: true
    },
    {
      _id: "64f1a2b3c4d5e6f7a8b9c0d2",
      nombre: "Temperatura Ambiental",
      tipo: { _id: "tipo2", nombre: "Área" },
      tipografica: { _id: "tipog2", nombre: "Temperatura" },
      proyecto: {
        _id: "proj2",
        nombre: "Monitoreo Ambiental",
        empresa: {
          _id: "empresa1",
          nombre: "Empresa Principal"
        }
      },
      sensores: [
        {
          _id: "sensor2",
          nombre: "Sensor Temperatura",
          alias: "TEMP_01",
          unidades: "°C",
          tipo: { _id: "tipo_sensor2", nombre: "Temperatura" },
          empresa: "empresa1",
          data: [
            { value: 22.5, date: "2024-01-15T10:00:00Z" },
            { value: 23.1, date: "2024-01-15T11:00:00Z" },
            { value: 24.2, date: "2024-01-15T12:00:00Z" },
            { value: 25.8, date: "2024-01-15T13:00:00Z" },
            { value: 26.3, date: "2024-01-15T14:00:00Z" },
            { value: 25.9, date: "2024-01-15T15:00:00Z" },
            { value: 24.7, date: "2024-01-15T16:00:00Z" },
            { value: 23.4, date: "2024-01-15T17:00:00Z" },
            { value: 22.8, date: "2024-01-15T18:00:00Z" },
            { value: 22.1, date: "2024-01-15T19:00:00Z" }
          ]
        }
      ],
      createdAt: "2024-01-14T10:15:00Z",
      favorita: true
    },
    {
      _id: "64f1a2b3c4d5e6f7a8b9c0d3",
      nombre: "Humedad Relativa",
      tipo: { _id: "tipo3", nombre: "Gauge" },
      tipografica: { _id: "tipog3", nombre: "Humedad" },
      proyecto: {
        _id: "proj2",
        nombre: "Monitoreo Ambiental",
        empresa: {
          _id: "empresa1",
          nombre: "Empresa Principal"
        }
      },
      sensores: [
        {
          _id: "sensor3",
          nombre: "Sensor Humedad",
          alias: "HUM_01",
          unidades: "%",
          tipo: { _id: "tipo_sensor3", nombre: "Humedad" },
          empresa: "empresa1",
          data: [
            { value: 65.2, date: "2024-01-15T10:00:00Z" },
            { value: 63.8, date: "2024-01-15T11:00:00Z" },
            { value: 67.4, date: "2024-01-15T12:00:00Z" },
            { value: 69.1, date: "2024-01-15T13:00:00Z" },
            { value: 71.5, date: "2024-01-15T14:00:00Z" },
            { value: 68.9, date: "2024-01-15T15:00:00Z" },
            { value: 66.3, date: "2024-01-15T16:00:00Z" },
            { value: 64.7, date: "2024-01-15T17:00:00Z" },
            { value: 63.2, date: "2024-01-15T18:00:00Z" },
            { value: 62.8, date: "2024-01-15T19:00:00Z" }
          ]
        }
      ],
      createdAt: "2024-01-13T15:20:00Z",
      favorita: true
    }
  ],
  contadores: {
    proyectos: 15,
    tarjetas: { 
      activas: 120, 
      total: 150, 
      porcentajeActivo: 80 
    },
    sensores: { 
      activos: 240, 
      total: 300, 
      porcentajeActivo: 80 
    }
  },
  ultimosSensores: [
    {
      _id: "sensor1",
      nombre: "Sensor de Temperatura",
      alias: "TEMP_01",
      unidades: "°C",
      tipo: { _id: "tipo_sensor1", nombre: "Temperatura" },
      tarjeta: {
        _id: "tarjeta1",
        nombre: "Tarjeta Principal",
        elemento: {
          _id: "elemento1",
          nombre: "Sala de Máquinas",
          empresa: "empresa1",
          proyecto: {
            _id: "proj1",
            nombre: "Monitoreo Industrial",
            empresa: {
              _id: "empresa1",
              nombre: "Empresa Principal"
            }
          }
        }
      },
      ultimoValor: {
        valor: 23.5,
        fecha: "2024-01-15T14:30:00Z",
        peligrosidad: "normal"
      },
      fechaConsulta: "2024-01-15T14:35:00Z",
      estatusDispositivo: true
    },
    {
      _id: "sensor2",
      nombre: "Sensor de Humedad",
      alias: "HUM_01",
      unidades: "%",
      tipo: { _id: "tipo_sensor2", nombre: "Humedad" },
      tarjeta: {
        _id: "tarjeta2",
        nombre: "Tarjeta Ambiental",
        elemento: {
          _id: "elemento2",
          nombre: "Oficina Principal",
          empresa: "empresa1",
          proyecto: {
            _id: "proj2",
            nombre: "Confort Ambiental",
            empresa: {
              _id: "empresa1",
              nombre: "Empresa Principal"
            }
          }
        }
      },
      ultimoValor: {
        valor: 65.8,
        fecha: "2024-01-15T14:25:00Z",
        peligrosidad: "normal"
      },
      fechaConsulta: "2024-01-15T14:30:00Z",
      estatusDispositivo: true
    },
    {
      _id: "sensor3",
      nombre: "Sensor de Presión",
      alias: "PRES_01",
      unidades: "Pa",
      tipo: { _id: "tipo_sensor3", nombre: "Presión" },
      tarjeta: {
        _id: "tarjeta3",
        nombre: "Tarjeta Hidráulica",
        elemento: {
          _id: "elemento3",
          nombre: "Sistema Hidráulico",
          empresa: "empresa1",
          proyecto: {
            _id: "proj3",
            nombre: "Control Hidráulico",
            empresa: {
              _id: "empresa1",
              nombre: "Empresa Principal"
            }
          }
        }
      },
      ultimoValor: {
        valor: 1013.25,
        fecha: "2024-01-15T14:20:00Z",
        peligrosidad: "advertencia"
      },
      fechaConsulta: "2024-01-15T14:25:00Z",
      estatusDispositivo: true
    },
    {
      _id: "sensor4",
      nombre: "Sensor de Corriente",
      alias: "AMP_01",
      unidades: "A",
      tipo: { _id: "tipo_sensor4", nombre: "Amperaje" },
      tarjeta: {
        _id: "tarjeta4",
        nombre: "Tarjeta Eléctrica",
        elemento: {
          _id: "elemento4",
          nombre: "Panel Principal",
          empresa: "empresa1",
          proyecto: {
            _id: "proj1",
            nombre: "Monitoreo Industrial",
            empresa: {
              _id: "empresa1",
              nombre: "Empresa Principal"
            }
          }
        }
      },
      ultimoValor: {
        valor: 15.2,
        fecha: "2024-01-15T14:15:00Z",
        peligrosidad: "peligro"
      },
      fechaConsulta: "2024-01-15T14:20:00Z",
      estatusDispositivo: false
    },
    {
      _id: "sensor5",
      nombre: "Sensor de Voltaje",
      alias: "VOLT_01",
      unidades: "V",
      tipo: { _id: "tipo_sensor5", nombre: "Voltaje" },
      tarjeta: {
        _id: "tarjeta5",
        nombre: "Tarjeta Eléctrica 2",
        elemento: {
          _id: "elemento5",
          nombre: "Panel Secundario",
          empresa: "empresa1",
          proyecto: {
            _id: "proj1",
            nombre: "Monitoreo Industrial",
            empresa: {
              _id: "empresa1",
              nombre: "Empresa Principal"
            }
          }
        }
      },
      ultimoValor: {
        valor: 220.5,
        fecha: "2024-01-15T14:10:00Z",
        peligrosidad: "normal"
      },
      fechaConsulta: "2024-01-15T14:15:00Z",
      estatusDispositivo: true
    }
  ],
  consumoEnergia: {
    totalConsumo: 1250.75,
    consumoPorTipo: {
      "Kilowatt": 850.25,
      "Amperaje": 400.50
    },
    consumoPorDia: [
      { fecha: "2024-01-01", consumo: 45.2 },
      { fecha: "2024-01-02", consumo: 52.8 },
      { fecha: "2024-01-03", consumo: 48.1 },
      { fecha: "2024-01-04", consumo: 51.4 },
      { fecha: "2024-01-05", consumo: 49.7 },
      { fecha: "2024-01-06", consumo: 47.3 },
      { fecha: "2024-01-07", consumo: 44.8 },
      { fecha: "2024-01-08", consumo: 46.9 },
      { fecha: "2024-01-09", consumo: 53.2 },
      { fecha: "2024-01-10", consumo: 50.8 },
      { fecha: "2024-01-11", consumo: 48.5 },
      { fecha: "2024-01-12", consumo: 52.1 },
      { fecha: "2024-01-13", consumo: 49.3 },
      { fecha: "2024-01-14", consumo: 51.7 },
      { fecha: "2024-01-15", consumo: 47.9 }
    ],
    sensoresIncluidos: 12,
    periodoCalculado: {
      inicio: "2024-01-01T00:00:00Z",
      fin: "2024-01-31T23:59:59Z",
      mes: "Enero 2024"
    }
  },
  userInfo: {
    rol: "admin",
    empresa: null,
    filtroAplicado: "todos"
  }
};

export const mockDashboardDataEmpresa = {
  ...mockDashboardData,
  userInfo: {
    rol: "empresa",
    empresa: "TechCorp Solutions",
    filtroAplicado: "empresa"
  },
  contadores: {
    proyectos: 5,
    tarjetas: { 
      activas: 45, 
      total: 50, 
      porcentajeActivo: 90 
    },
    sensores: { 
      activos: 85, 
      total: 95, 
      porcentajeActivo: 89 
    }
  }
};

export const mockDashboardDataSuperAdmin = {
  ...mockDashboardData,
  userInfo: {
    rol: "superadmin",
    empresa: null,
    filtroAplicado: "todos"
  },
  contadores: {
    proyectos: 50,
    tarjetas: { 
      activas: 450, 
      total: 500, 
      porcentajeActivo: 90 
    },
    sensores: { 
      activos: 850, 
      total: 1000, 
      porcentajeActivo: 85 
    }
  }
};

export const mockDashboardDataEmpty = {
  graficasFavoritas: [],
  contadores: {
    proyectos: 0,
    tarjetas: { activas: 0, total: 0, porcentajeActivo: 0 },
    sensores: { activos: 0, total: 0, porcentajeActivo: 0 }
  },
  ultimosSensores: [],
  consumoEnergia: {
    totalConsumo: 0,
    consumoPorTipo: {},
    consumoPorDia: [],
    sensoresIncluidos: 0,
    periodoCalculado: null
  },
  userInfo: {
    rol: "empresa",
    empresa: "Nueva Empresa",
    filtroAplicado: "empresa"
  }
};
